import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type ProfileMenuButtonProps = {
    onClick: () => void;
};

const ProfileMenuButton = ({ onClick }: ProfileMenuButtonProps) => {
    const { t } = useGranite();

    return (
        <Button
            color={"link"}
            className={cn("tw:p-0 tw:inline-block!")}
            onClick={onClick}
        >
            <i className={"las la-angle-left"} />
            {t("profileMenuButton.link.myProfile")}
        </Button>
    );
};

export default ProfileMenuButton;
